import {
  Component,
  ChangeDetectionStrategy,
  signal,
  input,
  output,
  booleanAttribute
} from '@angular/core';
import { ProjectStatuses } from '@zerops/models/project';

type InfoCardColor = 'orange' | 'green' | 'base';

@Component({
  selector: 'zui-ip-info-card',
  templateUrl: './ip-info-card.component.html',
  styleUrl: './ip-info-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IpInfoCardComponent {

  ipV4 = input<string>();
  sharedIpV4 = input<string>();
  ipV4PendingRequest = input(false);
  ipV4AddonInProcess = input(false);
  ipV6 = input<string>();
  requestIpv4Key = input<string>();
  requestIpV4ButtonText = input<string>();
  projectName = input<string>();
  projectId = input<string>();
  projectStatus = input<ProjectStatuses>();
  publicZone = input<string>();
  color = input<InfoCardColor>('base');
  showOnlyIpV4Button = input(false, { transform: booleanAttribute });
  showDesc = input(false, { transform: booleanAttribute });
  requestIpV4 = output<void>();
  selectedCard = signal<string>('CNAME');
  projectStatuses = ProjectStatuses;

}
